import { action, thunk } from 'easy-peasy';
import { getShortLinkolns, saveShortLinkoln } from '../services/ShortLinkolns';

const ShortLinkolnsModel = {
  short_linkolns: [],
  showShortLinkolns: action((state, new_short_linkolns) => {
    state.short_linkolns = new_short_linkolns || [];
  }),
  saveShortLinkoln: thunk(async (actions, {domain, short_linkoln}) => {
    console.log("saving short linkoln for " + domain);
    console.log(short_linkoln);
    await saveShortLinkoln(domain, short_linkoln);
    await actions.getShortLinkolns();
  }),
  getShortLinkolns: thunk(async (actions, domain, {getStoreState}) => {
    if (!domain) {
      let state = getStoreState();
      domain = state.current_domain.domain;
    }
    let short_linkolns = await getShortLinkolns(domain);
    actions.showShortLinkolns(short_linkolns);
  })
};

export default ShortLinkolnsModel;
